<template>
  <div class="columns is-multiline">
    <div v-for="item in items" :key="item.card.uid" class="column is-4">
      <ProjectImage
        :hidden="hidden"
        :title="item.card.title"
        :subtitle="item.card.subtitle"
        :image="`${$helpers.url}image/${item.images[0].name}?size=400`"
        :link="`/projekt/${item.card.path}`"
      ></ProjectImage>
    </div>
  </div>
</template>

<script>
import ProjectImage from "@/components/singles/ProjectImage.vue";
export default {
  components: { ProjectImage },
  props: ["hidden", "items"],
  data() {
    return {
      // items: []
    };
  },
  created() {
    // this.GetProjects();
  },
  mounted() {},
  beforeDestroy() {},
  methods: {
    // async GetProjects() {
    //   let result = await this.$helpers.PostApi(
    //     "get/pageProjects",
    //     {
    //       pageName: "/",
    //       active: true,
    //       cover: true
    //     },
    //     true
    //   );
    //   this.items = result;
    // }
  },
};
</script>
